<template>
  <div class="merge-confirmation">
    <h2>🔀 Ready to Merge</h2>
    <p class="subtitle">
      Final confirmation before merging {{ branchName }} to main
    </p>

    <div v-if="!comparisonSummary || !approvalData" class="loading-summary">
      <p>Loading merge details...</p>
    </div>

    <div v-else class="confirmation-panel">
      <h3>This will:</h3>
      <ul>
        <li>
          ✓ Merge {{ comparisonSummary.drift?.modified || 0 }} modified policies to
          main
        </li>
        <li>✓ Add {{ comparisonSummary.drift?.added || 0 }} new policies to main</li>
        <li>
          ✓ Remove {{ comparisonSummary.drift?.deleted || 0 }} policies from main
        </li>
        <li>✓ Create audit trail entry</li>
        <li>✓ Delete capture branch</li>
      </ul>

      <div class="approval-info">
        <strong>Approved by:</strong> {{ approvalData.approvedBy || 'Unknown' }}<br />
        <strong>Approved at:</strong> {{ formatDate(approvalData.approvedAt) }}
      </div>
    </div>

    <div class="actions">
      <button class="btn-secondary" @click="$emit('back')">← Back</button>
      <button class="btn-primary" @click="$emit('merge')">Create Pull Request</button>
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/services/date-utils.js";

export default {
  name: "MergeConfirmation",

  props: {
    branchName: String,
    clientCode: String,
    approvalData: Object,
    comparisonSummary: Object,
  },

  methods: {
    formatDate(dateString) {
      return formatDate(dateString, { fallback: "Unknown" });
    },
  },
};
</script>

<style scoped>
.merge-confirmation {
  padding: 24px;
}

.merge-confirmation h2 {
  margin: 0 0 8px 0;
  font-size: 20px;
}

.subtitle {
  margin: 0 0 24px 0;
  color: #666;
  font-size: 14px;
}

.confirmation-panel {
  background: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 24px;
}

.confirmation-panel h3 {
  margin: 0 0 12px 0;
  font-size: 16px;
}

.confirmation-panel ul {
  margin: 0 0 20px 0;
  padding-left: 20px;
}

.confirmation-panel li {
  margin-bottom: 8px;
  font-size: 14px;
}

.approval-info {
  padding-top: 16px;
  border-top: 1px solid #c3e6cb;
  font-size: 14px;
}

.actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.btn-primary,
.btn-secondary {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}

.btn-primary {
  background: #28a745;
  color: white;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}
</style>
